import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'dashboard_amc.mes_contracts.title',
  },
  subTitle: {
    id: 'amc_details.sub_title',
  },
  lastRefunds: {
    id: 'amc_details.my_last_refunds',
  },
  FindMoreAboutContracts: {
    id: 'amc_details.find_more_contracts',
  },
  myBeneficiary: {
    id: 'amc_details.my_beneficiary',
  },
  howAddBenificiary: {
    id: 'amc_details.how_to_add_benificiary',
  },
  filter: {
    id: 'amc_details.filter',
  },
  followUpMyRequests: {
    id: 'amc_details.follow_up_my_requests',
  },
});
